// extracted by css-extract-rspack-plugin
export default {"borderTop":"F5cLu","borderBottom":"R789n","action":"ah2Kb"};